import { WsMessage } from '../../clients/chat/types';
import { Field } from '../../model/types';

export enum GrispiNewsTicketActionTypeMap {
    u = 'u', //update
    d = 'd', //delete
    g = 'g', //g-social , g-social , not needed for now
    m = 'm', //mention
    c = 'c' //comment
}
export enum GrispiNewsNotificationTypeMap {
    TICKET_NEWS = 'TICKET_NEWS',
    USER_NEWS = 'USER_NEWS',
    SESSION_NEWS = 'SESSION_NEWS',
    TENANT_NEWS = 'TENANT_NEWS',
    CHAT_MESSAGE = 'CHAT_MESSAGE'
}
export type GrispiNewsResponseType = {
    c: string;
    d: { a: GrispiNewsTicketActionTypeMap; fields?: Field[]; k?: string; message?: WsMessage };
    t: number;
    u?: number;
};
export type GrispiNewsNotificationType = {
    id: string;
    channel: string;
    action: GrispiNewsTicketActionTypeMap;
    ticketKey?: string;
    isSeen: boolean;
    type: GrispiNewsNotificationTypeMap;
    eventDate: number;
    user?: number;
    message?: WsMessage;
};
export type GrispiNewsTicketNotificationType = {
    id: string;
    tabKey: string;
    action: GrispiNewsTicketActionTypeMap;
    fields?: Field[];
    isNeedUpdate?: boolean;
    eventDate: number;
    isSeen: boolean;
    user?: number;
};

// == Ticket update

// {
//  c: "urn:t/dedeler/r/TICKET-13", //channel
//  d: {       //data
//   a: "u",      //action
//   fields: [{key: "ts.status", value: "3"}]
//  }
// }

// == Ticket delete

// {
//  c: "urn:t/dedeler/r/TICKET-13", //channel
//  d: {       //data
//   a: "d"      //action
//  }
// }

// == General structure of SSE message

// {
//  c: "urn:t/sessionId", //channel
//  d: {       //data
//   a: ""      //action
//  }
// }
